import React from "react";
import Link from "./Link";
import { Box } from "@mui/material";
import { Container } from "@mui/system";

const Footer = () => {
  return (
    <Box>
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row",
              lg: "row",
              xl: "row",
            },
            justifyContent: "space-between",
            paddingBottom: "5px",
          }}>
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}>
            <h3 className="text-xl lg:text-2xl font-medium">Support</h3>
            <Box
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row",
                  xl: "row",
                },
                justifycontent: "space-between",
                gap: {
                  xs: 0,
                  sm: 0,
                  md: 2,
                  lg: 2,
                  xl: 2,
                },
              }}>
              <Link href="" className="text-gray-400 font-normal">
                <div className="my-1 text-sm lg:text-base lg:my-0">Contact</div>
              </Link>
              <Link href="" className="text-gray-400 font-normal">
                <div className="my-1 text-sm lg:text-base lg:my-0">
                  Terms and Condition
                </div>
              </Link>
              <Link href="" className="text-gray-400 font-normal">
                <div className="my-1 text-sm lg:text-base lg:my-0">
                  Privacy Policies
                </div>
              </Link>
            </Box>
          </div>
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}>
            <h3 className="text-xl lg:text-2xl font-medium">Business</h3>
            <Box
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row",
                  xl: "row",
                },
                justifycontent: "space-between",
                gap: {
                  xs: 0,
                  sm: 0,
                  md: 2,
                  lg: 2,
                  xl: 2,
                },
              }}>
              <Link
                href=""
                className=" text-sm lg:text-md text-gray-400 font-normal">
                <div className="my-1 lg:my-0">Blog</div>
              </Link>
              <Link
                href=""
                className=" text-sm lg:text-md text-gray-400 font-normal">
                <div className="my-1 lg:my-0">Travel guide</div>
              </Link>

              <Link
                href=""
                className=" text-sm lg:text-md text-gray-400 font-normal">
                <div className="my-1 lg:my-0">About Teksa</div>
              </Link>
            </Box>
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
